import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

const Footer = props => {
  return (
    <footer className={props.isSignin ? "hideFooterMobile" : ""}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 col-lg-4 d-none d-md-block">
            <ul className="d-flex flex-row align-items-center">
              <li>
                <Link className="" to="/">
                  <img
                    className="logo"
                    src="/assets/logo.png"
                    alt="Logo Image"
                  />
                </Link>
              </li>
              <li>Business. Markets. Startups.</li>
            </ul>
          </div>
          <div className="col-xs-12 col-md-6 col-lg-4 offset-lg-4">
            <div className="d-flex flex-row align-items-center justify-content-between justify-content-md-end social-icons">
              <div>
                <a
                  href="https://apps.apple.com/us/app/apple-store/id1494428911"
                  target="_blank"
                >
                  <img src="/assets/svg/app-store.svg" alt="Apple App Image" />
                </a>
              </div>
              <div>
                <ul>
                  <li>
                    <a
                      href="https://twitter.com/ausbiztv"
                      target="_blank"
                      className="twitter"
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/711458752615326"
                      className="facebook"
                      target="_blank"
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/ausbiztv"
                      className="linkedin"
                      target="_blank"
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="borderBottom"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-lg-4 copyright text-center text-md-left">
            <div className="d-sm-flex flex-sm-row align-items-sm-center">
              &copy; Copyright {new Date().getFullYear()} Ausbiz TV Pty Ltd
            </div>
          </div>
          <div className="col-md-6 col-lg-4 offset-lg-4 staticLinks text-center d-none d-md-block">
            <ul className="d-flex flex-row align-items-center justify-content-md-end">
              <li>
                <a href="https://company.ausbiz.com.au/" target="_blank">
                  About
                </a>
              </li>
              <li>
                <a href="https://company.ausbiz.com.au/contact" target="_blank">
                  Contact
                </a>
              </li>
              <li>
                <a href="https://company.ausbiz.com.au/privacy-policy" target="_blank">
                  Privacy policy
                </a>
              </li>
              <li>
                <a href="https://company.ausbiz.com.au/terms-of-service" target="_blank">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = state => {
  return {};
};

export default connect(mapStateToProps)(Footer);
